import styled from 'styled-components';
import { Breakpoints } from '@estee/elc-base-theme';
import { SliderView } from '@estee/elc-slider';

export const StyledSlider = styled(SliderView)`
    padding: 0 15px;
    @media only screen and (min-width: ${Breakpoints.desktop}px) {
        padding: 0;
    }
`;
